export default __webpack_public_path__ + "static/media/phone-player-app-big.2807b750.png";